import axiosInstance from "../axiosConfig";
import { APIResponse, Event, CreateEventPayload } from "./eventService.types";

export const fetchEvents = async (
  page: number = 1,
  pageSize: number = 10,
  ordering: string = ""
): Promise<APIResponse<Event>> => {
  const url = `/event_calendar/events/`;
  try {
    const response = await axiosInstance.get<APIResponse<Event>>(url, {
      params: {
        page,
        page_size: pageSize,
        ordering,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении списка событий:", error);
    throw error;
  }
};

export const fetchEventById = async (eventId: number): Promise<Event> => {
  const url = `/event_calendar/events/${eventId}/`;
  try {
    const response = await axiosInstance.get<Event>(url);
    return response.data;
  } catch (error) {
    console.error(`Ошибка при получении события с ID ${eventId}:`, error);
    throw error;
  }
};

export const createEvent = async (payload: CreateEventPayload): Promise<Event> => {
  const url = `/event_calendar/events/`;
  try {
    const response = await axiosInstance.post<Event>(url, payload);
    return response.data;
  } catch (error) {
    console.error("Ошибка при создании события:", error);
    throw error;
  }
};

export const updateEvent = async (id: number, payload: CreateEventPayload): Promise<Event> => {
  const url = `/event_calendar/events/${id}/`;
  try {
    const response = await axiosInstance.put<Event>(url, payload);
    return response.data;
  } catch (error) {
    console.error(`Ошибка при обновлении события с ID ${id}:`, error);
    throw error;
  }
};

export const deleteEvent = async (id: number): Promise<void> => {
  const url = `/event_calendar/events/${id}/`;
  try {
    await axiosInstance.delete(url);
  } catch (error) {
    console.error(`Ошибка при удалении события с ID ${id}:`, error);
    throw error;
  }
};
